import { useMutation } from '@tanstack/react-query'
import { insertLink } from '../../../service/challenge'

function useInsertLinkChallenge() {
  return useMutation({
    mutationKey: ['insert-link'],
    mutationFn: insertLink,
  })
}

export default useInsertLinkChallenge
